import { getToken, setToken, removeToken } from "@/utils/auth";
import { getKey, setKey } from "@/utils/auth";
import { getUserInfoMes, getCmpInfoForUser } from "@api/order.js";
import myOrderList from "../../views/myorder/index.vue";
const token = getToken();
const sourceId = getKey("sourceId");
const sourceType = getKey("sourceType");
const companyMainUserAccountId = getKey("companyMainUserAccountId");

const state = {
  token: token,
  userId: "",
  userName: "",
  roles: [],
  sourceId: sourceId ? sourceId : "",
  sourceType: sourceType ? sourceType : 0,
  auditPerson: "", // 审核人
  companyMainUserAccountId: companyMainUserAccountId
    ? companyMainUserAccountId
    : "",
  organizationId: "",
  userAccountId: "",
  tenantId: "",
};

const mutations = {
  setusuallyToken: (state, payload) => {
    state.token = payload.token;

    if (payload.tag == "usually") {
      getUserInfoMes(payload.token).then((res) => {
        if (res.data) {
          state.userName = res.data.data.realName || "";
          state.auditPerson = res.data.data.realName || "";
          state.userId = res.data.data.userId || "";
          state.organizationId = res.data.data.organizationId || "";
          sessionStorage.setItem("userName", res.data.data.userName);
          sessionStorage.setItem("auditPerson", res.data.data.auditPerson);
          sessionStorage.setItem("userId", res.data.data.userId);
          sessionStorage.setItem(
            "organizationId",
            res.data.data.organizationId
          );
        }
      });
    } else if (payload.tag == "myOrder") {
      getCmpInfoForUser({
        token: payload.token,
        companyId: payload.companyId
      }).then((res) => {
        if (res.data) {
          // state.userAccountId = res.data.data.userAccountId || "";
          state.tenantId = res.data?.tenantId || "";
          sessionStorage.setItem("tenantId", res.data?.tenantId || "");
          // state.userId = res.data.data.userId || "";
        }
      });
    }
    // if (window.location.pathname.includes("/myorder/")) {
    //   return;
    // }
    // console.log("store user commit set token =>", token);
    setToken(payload.token);
  },
  setTenantId(state, val) {
    state.tenantId = val;
    sessionStorage.setItem("tenantId", val);
  },
  setOrderToken(state, userAccountId) {
    state.userAccountId = userAccountId;
  },
  setUserName: (state, userName) => {
    state.userName = userName;
  },
  setAuditPerson: (state, userName) => {
    state.auditPerson = userName;
  },
  setUserId: (state, id) => {
    state.userId = id;
  },
  setOrganizationId(state, organizationId) {
    state.organizationId = organizationId;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  setSourceId(state, id) {
    state.sourceId = id;
    setKey("sourceId", id);
  },
  setSourceType(state, type) {
    state.sourceType = type;
    setKey("sourceType", type);
  },
  setCompanyMainUserAccountId(state, id) {
    state.companyMainUserAccountId = id;
    setKey("companyMainUserAccountId", id);
  },
};

const actions = {
  //TODO
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      commit("setRoles", [1]);
      resolve({ roles: [1] });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("setToken", "");
      commit("setRoles", []);
      removeToken();
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
